module.exports = __webpack_public_path__ + "img/logo-empower-branco.bf956053.png";